<template>
<div class="max-w-full flex flex-col items-center justify-center text-center p-12 m:p-24 bg-white">
<h2 class="text-3xl sm:text-4xl md:text-5xl max-w-screen-lg text-pink-900 font-serif pb-6 m:pb-10 mx-auto ">Beautifully designed wedding  stationery for your unforgettable day.</h2>
<p class="text-md md:text-lg max-w-screen-md mx-auto text-gray-600 pb-6 m:pb-10">We offer a full suite of wedding stationery, including invitations, menus, and more, designed to elevate your celebration and create lasting impressions.</p>
 <a
          href="https://form.jotform.com/243653030424043"
          target="_blank"
          class="bg-pink-900 text-white px-6 py-3 rounded-lg text-lg font-medium hover:bg-pink-700 transition">
          Submit an Enquiry
        </a>
</div>
</template>

<script>
export default {
  name: 'TaglineMessage',
  
}


</script>

<style scoped>

</style>
